import React from "react";

export default function ERPSideDrawer({
  open,
  title,
  tabs = [],
  activeTab,
  onTabChange,
  children,
  onClose,
  footer,
  width = 760,
}) {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        zIndex: 2000,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          height: "100%",
          width,
          background: "#fff",
          display: "flex",
          flexDirection: "column",
          boxShadow: "-4px 0 20px rgba(0,0,0,.2)",
        }}
      >
        {/* ================= HEADER ================= */}
        <div
          style={{
            padding: "16px 20px",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: 600,
            fontSize: 18,
          }}
        >
          {title}
          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              fontSize: 20,
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        {/* ================= TABS ================= */}
        {tabs.length > 0 && (
          <div
            style={{
              display: "flex",
              borderBottom: "1px solid #e5e7eb",
              paddingLeft: 12,
            }}
          >
            {tabs.map((t) => (
              <button
                key={t.key}
                onClick={() => onTabChange(t.key)}
                style={{
                  padding: "12px 16px",
                  border: "none",
                  background: "transparent",
                  fontWeight: 600,
                  borderBottom:
                    activeTab === t.key
                      ? "3px solid #0f766e"
                      : "3px solid transparent",
                  color:
                    activeTab === t.key
                      ? "#0f766e"
                      : "#6b7280",
                  cursor: "pointer",
                }}
              >
                {t.label}
              </button>
            ))}
          </div>
        )}

        {/* ================= BODY ================= */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: 20,
            background: "#fafafa",
          }}
        >
          {children}
        </div>

        {/* ================= FOOTER ================= */}
        <div
          style={{
            padding: "14px 20px",
            borderTop: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
            background: "#fff",
          }}
        >
          {footer}
        </div>
      </div>
    </div>
  );
}
